import { render, staticRenderFns } from "./SetPagevar.vue?vue&type=template&id=31712bd2&scoped=true&"
import script from "./SetPagevar.vue?vue&type=script&lang=js&"
export * from "./SetPagevar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31712bd2",
  null
  
)

export default component.exports